import 'reflect-metadata';
import { ILogger } from './LoggerService';
import { INotification } from './NotificationService';
import { injectable } from 'inversify-props';
import { inject } from 'inversify';

export interface IErrorHandler {

	handle(error: any, defaultMessage: string): void;

}

@injectable()
export class ErrorHandler implements IErrorHandler {


	constructor(
		@inject('ILogger') private logger: ILogger,
		@inject('INotification') private notification: INotification) {

	}


	/** Handles the specified error message */
	public handle(error: any, defaultMessage: string): void {
		let message = defaultMessage;
		if (error != null) {
			if (error.response != null &&
				error.response.data != null &&
				error.response.data.message != null) {
				message = error.response.data.message;
			} else if (error.message === 'Network Error') {
				message = 'Connection to the server could not be established';
			}
			this.notification.error(message);
			throw error;
		}
		this.notification.error(message);
		this.logger.error(`[ERROR] ${message}`);
	}

}
